import { render } from "./multi-table-item.vue?vue&type=template&id=cca6a356&scoped=true&ts=true"
import script from "./multi-table-item.vue?vue&type=script&lang=ts"
export * from "./multi-table-item.vue?vue&type=script&lang=ts"

import "./multi-table-item.vue?vue&type=style&index=0&id=cca6a356&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cca6a356"]])

export default __exports__